import React from 'react'
import { Button } from 'src/components'
import { useStyles } from './styles'
import { useNavigate } from 'react-router-dom'

export const ActionsSection = ({ savedBirths, isSaving, handleSaveAll }: any) => {
  const navigate = useNavigate()
  const style = useStyles()

  const navigateBack = () => {
    navigate(-1)
  }
  return (
    <div className={style.actionsContainer}>
      <Button onClick={navigateBack} outlined>
        Cancelar
      </Button>

      <Button onClick={handleSaveAll} disabled={savedBirths.length === 0 || isSaving} isLoading={isSaving}>
        Salvar
      </Button>
    </div>
  )
}
